import type { ElementId } from '../types';

const widgetName = 'ProfileCard';

export const getElementId = (compId: string, elementId: ElementId) =>
  `${widgetName}-${compId}-${elementId}`;
